import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { easings } from "@apps/viewer/src/ts/config";

/**
 * Specification of the transition duration in milliseconds.
 */
const DURATION = 280;

/**
 * Simple css transition that'll slide the header down from the top of the
 * viewport, when the page has initially been rendered.
 */
// tslint:disable-next-line variable-name no-reserved-keywords
export const InitialSlide: React.FC<{
  in?: boolean;
  reversed?: boolean;
  children: (ref: RefObject<any>) => React.ReactNode;
}> = ({ reversed, children, ...props}) => {
  const className = `${
    reversed ? "layout__header__initialSlide--reversed" : ""
  } layout__header__initialSlide`.trim();
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      mountOnEnter
      timeout={DURATION}
      classNames={className}
      nodeRef={ref}
    >
      <>
        {children(ref)}

        <style jsx global>{`
          .layout__header__initialSlide-enter,
          .layout__header__initialSlide-appear {
            opacity: 0.001 !important;
            transform: translateY(-50%);
          }

          .layout__header__initialSlide--reversed.layout__header__initialSlide-enter,
          .layout__header__initialSlide--reversed.layout__header__initialSlide-appear {
            transform: translateY(50%);
          }

          .layout__header__initialSlide-enter-active,
          .layout__header__initialSlide-appear-active {
            opacity: 1 !important;
            transform: translateY(0) !important;

            /** Configura transition */
            transition: opacity ${DURATION}ms linear,
              transform ${DURATION * 0.8}ms ${easings.inOutQuad};
          }

          .layout__header__initialSlide-enter-done,
          .layout__header__initialSlide-appear-done {
            opacity: 1 !important;
          }
        `}</style>
      </>
    </CSSTransition>
  );
};
